import React from 'react'

import { Typography, Link, makeStyles } from '@material-ui/core'

import logo from 'images/yapay--blue.svg'

import styles from './styles'

const useStyles = makeStyles(styles)

const Footer = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <img alt="Logo" src={logo} className={classes.logo} />

      <Typography varinat="h4" color="textSecondary" className={classes.text}>
        Soluções de pagamento
      </Typography>

      <Typography>
        <Link
          href="https://www.yapay.com.br"
          target="_blank"
          rel="noopener noreferrer"
          color="textSecondary"
        >
          www.yapay.com.br
        </Link>
      </Typography>
    </div>
  )
}

export default Footer
